import service from './serverIiot'
export function queryApi (reqParam){
    let baseUrl = '/iiot-cg-app';
    return service({
            url:baseUrl+reqParam.url,
            method:"post",
			params:reqParam.params,
            data:reqParam.data,
			responseType:reqParam.responseType
        }
    );
}
export default queryApi